// User
export const UPDATE_USER = 'UPDATE_USER'
export const SET_USER = 'SET_USER'
export const REMOVE_USER_DATA = 'REMOVE_USER_DATA'
